import * as React from 'react';
import { ContactFormBrand } from '../../../models/apiModels';
import { getAppBrand, isBranded } from '../../../utilities';
import { GroupmeBrandedHeaderContainer } from '../containerComponents/GroupmeBrandedHeaderContainer';
import { SignUpBrandedHeaderContainer } from '../containerComponents/SignUpBrandedHeaderContainer';

interface BrandedFormHeaderProps {
    brand: ContactFormBrand;
}

interface BrandedHeaderProps {
    appName: string;
}

const BrandedHeaderBrandSelector = (props: BrandedFormHeaderProps) => {
    if (props.brand === ContactFormBrand.GroupMe) {
        return <GroupmeBrandedHeaderContainer />;
    } else if (props.brand === ContactFormBrand.SignUp) {
        return <SignUpBrandedHeaderContainer />;
    } else if (props.brand === ContactFormBrand.Teams) {
        return <br />;
    }
    return null;
};

export const BrandedHeader = (props: BrandedHeaderProps) => {
    if (isBranded(props.appName)) {
        return (
            <BrandedHeaderBrandSelector
                brand={getAppBrand(props.appName)}
            />
        );
    }

    return null;
};
